@if (auth.currentUser$ | async; as user) {
  <div class="user-avatar-wrapper">
    <button class="avatar-button" (click)="menu.toggle($event)" #avatarButton>
      <app-avatar-initials
        [name]="user.full_name || user.name || ''"
        [avatarUrl]="user.avatar"
        [size]="40"
      />
    </button>
    <p-menu #menu [model]="userMenuItems" [popup]="true" class="user-menu" appendTo="body" [baseZIndex]="1300"></p-menu>
  </div>
} @else {
  <app-button (click)="onLoginClick()" [label]="'app.login' | translate" [shadow]="false"
              color="light"></app-button>
}
